export const initialState = {
    data: {},
    loading: true,
}